// Lightweight confetti burst — no dependency. Particles originate spread ACROSS
// the given element's area (e.g. the whole discovery card), then burst outward +
// fall and fade. Uses the Web Animations API (fine in WKWebView).
export function burstConfetti(origin) {
  const colors = ["#7c3aed", "#f43f5e", "#c026d3", "#10b981", "#f59e0b", "#3b82f6"]

  const rect = origin && origin.getBoundingClientRect ? origin.getBoundingClientRect() : null

  const layer = document.createElement("div")
  Object.assign(layer.style, {
    position: "fixed", inset: "0", pointerEvents: "none", zIndex: "100000", overflow: "hidden",
  })
  document.body.appendChild(layer)

  // More particles to fill a whole card.
  const COUNT = 70
  for (let i = 0; i < COUNT; i++) {
    // Spread origins across the element's full area so the burst covers the whole card.
    const startX = rect ? rect.left + Math.random() * rect.width  : Math.random() * window.innerWidth
    const startY = rect ? rect.top  + Math.random() * rect.height : window.innerHeight / 3

    const p = document.createElement("div")
    const size = 6 + Math.random() * 7
    Object.assign(p.style, {
      position: "absolute", left: `${startX}px`, top: `${startY}px`,
      width: `${size}px`, height: `${size}px`,
      background: colors[i % colors.length],
      borderRadius: i % 3 === 0 ? "50%" : "2px",
      willChange: "transform, opacity",
    })
    layer.appendChild(p)

    const angle    = Math.random() * Math.PI * 2
    const velocity = 70 + Math.random() * 200
    const dx       = Math.cos(angle) * velocity
    const dy       = Math.sin(angle) * velocity - 120        // bias upward on burst
    const rot      = Math.random() * 720 - 360
    const duration = 1100 + Math.random() * 800

    p.animate(
      [
        { transform: "translate(0,0) rotate(0deg)", opacity: 1 },
        { transform: `translate(${dx}px, ${dy + 380}px) rotate(${rot}deg)`, opacity: 0 },
      ],
      { duration, easing: "cubic-bezier(0.15, 0.6, 0.35, 1)", fill: "forwards" }
    )
  }

  setTimeout(() => layer.remove(), 2100)
}
